import { createSlice } from '@reduxjs/toolkit';

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    globalLoading: false,
    kcUser: {},
    header: {
      title: 'Hunter CRM',
      subTitle: undefined,
      actions: [],
      tabs: [],
    },
    isBaseRouteVisited: false,
    dispatchModal: {
      type: undefined,
      data: undefined,
    },
    isLogged: false,
  },
  reducers: {
    setGlobalLoading: (state, action) => ({
      ...state,
      globalLoading: action.payload,
    }),
    setKCUser: (state, action) => ({
      ...state,
      kcUser: {
        ...action.payload,
      },
    }),
    setIsBaseRouteVisited: (state, { payload }) => {
      state.isBaseRouteVisited = payload;
    },
    setHeaderTitle: (state, action) => ({
      ...state,
      header: {
        ...state.header,
        title: action.payload,
      },
    }),
    setHeaderSubTitle: (state, action) => ({
      ...state,
      header: {
        ...state.header,
        subTitle: action.payload,
      },
    }),
    setHeaderActions: (state, action) => ({
      ...state,
      header: {
        ...state.header,
        actions: action.payload,
      },
    }),
    setHeaderTabs: (state, action) => ({
      ...state,
      header: {
        ...state.header,
        tabs: action.payload,
      },
    }),
    setDispatchModal: (state, { payload }) => {
      return {
        ...state,
        dispatchModal: {
          type: payload ? payload.type : undefined,
          data: payload ? payload.data : undefined,
        },
      };
    },
    setIsLogged: (state, { payload }) => {
      return {
        ...state,
        isLogged: payload,
      };
    },
    setServerError: (state, { payload }) => ({
      ...state,
      serverError: payload,
    }),
  },
});

export const {
  setGlobalLoading,
  setKCUser,
  setIsBaseRouteVisited,
  setHeaderTitle,
  setHeaderSubTitle,
  setHeaderActions,
  setHeaderTabs,
  setDispatchModal,
  setIsLogged,
  setServerError,
} = appSlice.actions;

export const getGlobalLoading = (state: any) => state.app.globalLoading;
export const getKCUser = (state: any) => state.app.kcUser;
export const getHeader = (state: any) => state.app.header;
export const getIsBaseRouteVisited = (state: any): boolean =>
  state.app.isBaseRouteVisited;
export const getDispatchModal = (state: any) => state.app.dispatchModal;
export const getIsLogged = (state: any) => state.app.isLogged;
export const getServerError = (state: any) => state.app.serverError;

export default appSlice.reducer;
